import { useQuery } from '@tanstack/react-query';
import {
  LeadAssignableManagersResponseSchema,
  type LeadAssignableManagersResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function useLeadAssignableManagers(options: { enabled?: boolean } = {}) {
  const client = useApiClient();
  return useQuery<LeadAssignableManagersResponse>({
    queryKey: leadsKeys.assignableManagers(),
    queryFn: ({ signal }) =>
      client.get<LeadAssignableManagersResponse>(
        '/leads/assignable-managers',
        { signal },
        LeadAssignableManagersResponseSchema,
      ),
    enabled: options.enabled ?? true,
  });
}
